import React from 'react';
import { LogoWrap } from '../logo';
import { Link } from 'gatsby';

const LIVQUEST_CALVI_URL = 'https://galaxy.blob.core.windows.net/web/livquest_calvi_logo.png';

export const LivquestCalviLogo = () => (
  <LogoWrap>
    <div className="">
      <div className="liviu-logo px-3">
        <Link to="/">
          <img
            loading="lazy"
            src={LIVQUEST_CALVI_URL}
            alt="Les remparts de la mémoire"
            className="w-full max-w-[432px]"
          />
          <p className="liviu-logo-text"></p>
        </Link>
      </div>
    </div>
  </LogoWrap>
);
